<template>
  <div
    :class="classes"
    data-ui="date-time"
  >
    <!-- start and end time/date stamps are on the same day -->
    <template v-if="singleDaySession">
      <time
        :datetime="start"
        class="date-time__date date-time__date--single-day"
        data-ui="date-time-single-date"
      >
        {{ startFullDateDisplay }}
      </time>
      <span class="date-time__time">
        <span
          class="date-time__start-time"
          data-ui="date-time-single-time-start"
        >
          {{ startTime }}
        </span>
        <span>&ndash;</span>
        <span
          class="date-time__end-time"
          data-ui="date-time-single-time-end"
        >
          {{ endTime }}
        </span>
      </span>
    </template>

    <!-- start and end time/date stamps are on different days -->
    <template v-else>
      <div class="date-time__date date-time__date--start-day">
        <time
          :datetime="start"
          data-ui="date-time-multi-start-date"
        >
          {{ startFullDateDisplay }},
        </time>
        <span
          class="date-time__time"
          data-ui="date-time-multi-start-time"
        >
          {{ startTime }}
        </span>
      </div>
      &ndash;
      <div class="date-time__date date-time__date--end-day">
        <time
          :datetime="end"
          data-ui="date-time-multi-end-date"
        >
          {{ endFullDateDisplay }},
        </time>
        <span
          class="date-time__time"
          data-ui="date-time-multi-end-time"
        >
          {{ endTime }}
        </span>
      </div>
    </template>
  </div>
</template>

<script>
import moment from 'moment';
import 'moment-timezone';
import constants from '../common/constants';

export default {
  name: 'DateTimeComponent',
  props: {
    type: {
      type: String,
      required: false,
      default: '',
    },
    sessionStart: {
      type: String,
      required: true,
    },
    sessionEnd: {
      type: String,
      required: true,
    },
    timezone: {
      type: String,
      required: true,
    },
  },
  computed: {
    classes() {
      const { type, singleDaySession } = this;
      return [
        'date-time',
        { [`date-time--${type || ''}`]: !!type },
        `date-time--${singleDaySession ? 'single' : 'multi'}-day`,
      ];
    },
    // Returns parsed start date
    start() {
      return moment.parseZone(this.sessionStart).tz(this.timezone);
    },
    // Returns parsed end date
    end() {
      return moment.parseZone(this.sessionEnd).tz(this.timezone);
    },
    timezoneId() {
      return this.start.format('z');
    },
    endTime() {
      return `${this.getTime(this.end)} ${this.timezoneId}`;
    },
    endFullDateDisplay() {
      return this.getFullDateDisplay(this.end);
    },
    singleDaySession() {
      return moment(this.start).isSame(moment(this.end), 'day');
    },
    startFullDateDisplay() {
      return this.getFullDateDisplay(this.start);
    },
    startTime() {
      return this.getTime(this.start);
    },
  },
  methods: {
    getFullDateDisplay(date) {
      const { singleDaySession } = this;
      const format = singleDaySession ? constants.DATE_DISPLAY.LONG : constants.DATE_DISPLAY.SHORT;

      return moment(date).format(format);
    },
    getTime(date) {
      return moment(date).format(constants.DATE_DISPLAY.TIME);
    },
  },
};
</script>
